import styled from 'styled-components'
import { Row } from '@hfs/ui/components/Row'

export const FooterWrapper = styled(Row)`
  bottom: 32px;
  position: absolute;
  width: 100%;
`
